import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 7A5 5 0 0 0 7 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "IceCream";
const IceCream = memo(themed(Icon));
export {
  IceCream
};
//# sourceMappingURL=ice-cream.js.map
